// Thin host wrapper — Calendar (multi-tournament index). Public, no
// tier gate (INTEGRATION_PATCH §7). Selecting a card sets the active
// tournament context and navigates to its home. Founders additionally
// get the lifecycle control strip (PRD §5) — re-gated by
// is_strikza_admin() server-side; non-admins never see the chrome.
import { useNavigate } from "react-router-dom";
import { useIntlAccaTournaments } from "../../intl-acca/useIntlAccaTournaments.ts";
import { useIntlAccaTournamentAdmin } from "../../intl-acca/useIntlAccaTournamentAdmin.ts";
import { CalendarPage } from "./CalendarPage.tsx";

export function IntlAccaCalendarRoute(): JSX.Element {
  const navigate = useNavigate();
  const { loading, error, tournaments, setActive, refetch } =
    useIntlAccaTournaments();
  const { isAdmin, busyId, error: adminError, advance } =
    useIntlAccaTournamentAdmin(refetch);
  return (
    <CalendarPage
      loading={loading}
      error={error}
      tournaments={tournaments}
      onSelectTournament={(id) => {
        setActive(id);
        navigate(`/intl-acca/${id}`);
      }}
      admin={{ isAdmin, busyId, error: adminError, advance }}
    />
  );
}
